import type {
    CompetencyTranslationChangeRequest,
    CompetencyTranslationGroup,
    CompetencyTranslationGroupSummary,
} from '@/types/competencies/CompetencyTranslation';

import { api } from '@/api/api';

export default {
    async getCompetencyTranslations(): Promise<CompetencyTranslationGroup[]> {
        const response = await api.get('/competencytranslation');

        return response.data;
    },

    async getGroupSummaries(): Promise<CompetencyTranslationGroupSummary[]> {
        const response = await api.get('/competencytranslation/groups');

        return response.data;
    },

    async getGroupById(groupId: string): Promise<CompetencyTranslationGroup> {
        const response = await api.get(`/competencytranslation/groups/${groupId}`);

        return response.data;
    },

    async updateCompetencyTranslations(
        translations: CompetencyTranslationChangeRequest[],
    ): Promise<CompetencyTranslationGroup[]> {
        const response = await api.put('/competencytranslation', { translations });

        return response.data;
    },
};
